












import { Component, Prop, Vue } from "vue-property-decorator";
import CzCard from "../cz/CzCard.vue";
import CzChip from "../cz/CzChip.vue";
import CzIcon from "../cz/CzIcon.vue";
import CzPlanRow from "../cz/CzPlanRow.vue";

// The steps of a guideline in order (its sessions, then what it asks for at the end): when each one is done or can be
// done, and how its video or photo stands.
@Component({ components: { CzCard, CzChip, CzIcon, CzPlanRow } })
export default class GuidelineSessionList extends Vue {
  @Prop({ type: Array, required: true }) rows!: any[];
}
